import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {createReducer, on} from "@ngrx/store";
import {ITablePagerOptions} from "../../../shared/shared/table/components/table-pager/ITablePagerOptions";
  
import {HttpActionState} from "../../users/userslisting/store/users-listing.reducers";
import {IPlaybookCategoryDTO, IPlaybooksItemDTO} from "../dto/playbooks-listening.dto";
import {
    IPlaybookDefaultFilter
} from "../legal-hub-playbooks-listening/legal-hub-basic-filters/legal-hub-basic-filters.component";

import * as PlaybooksActions from './playbooks.actions';

export interface IPlaybookListeningState {
    search?: string;
    defaultFilters: IPlaybookDefaultFilter
    fetchPlaybooksRequestState?: HttpActionState;
    playbooks: EntityState<IPlaybooksItemDTO>;
    paging?: ITablePagerOptions;
    fetchCategoriesRequestState?: HttpActionState;
    deletePlaybookRequestState: HttpActionState;
    categories: IPlaybookCategoryDTO[];
}

export const playbookListingAdapter: EntityAdapter<IPlaybooksItemDTO> = createEntityAdapter<IPlaybooksItemDTO>({
    selectId: model => model.id,
});

const initialState: IPlaybookListeningState ={
    search: '',
    defaultFilters: null,
    fetchPlaybooksRequestState: HttpActionState.Init,
    paging: {
        pageSize: 1,
        currentPage: 1,
        pagesCount: 1,
        total: 0
    },
    playbooks: playbookListingAdapter.getInitialState(),
    fetchCategoriesRequestState: HttpActionState.Init,
    deletePlaybookRequestState: HttpActionState.Init,
    categories:[]
}


export const playbookListeningReducers = createReducer(
    initialState,
    on(PlaybooksActions.resetState, () => initialState ),
    on(PlaybooksActions.searchChange, (state, {searchValue}) => ({
        ...state,
        search: searchValue
    })),

    on(PlaybooksActions.defaultFilterChanged, (state, {filters}) => ({
        ...state,
        defaultFilters: filters
    })),
    
    on(PlaybooksActions.changePage, (state, {pageNumber}) => ({
        ...state,
        paging: {
            ...state.paging,
            currentPage: pageNumber
        }
    })),
    
    
    on(PlaybooksActions.fetchPlaybooks, (state)=> ({ 
        ...state,
        fetchPlaybooksRequestState: HttpActionState.Busy
    })),
    on(PlaybooksActions.fetchPlaybooksSucceeded, (state, {playbooksList}) => ({
        ...state,
        paging: {
            currentPage: playbooksList.current_page || 1,
            pagesCount: playbooksList.last_page || 1,
            pageSize: playbooksList.per_page || 1,
            total: playbooksList.total || 0
        },
        fetchPlaybooksRequestState: HttpActionState.Done,
        playbooks: playbookListingAdapter.setAll(playbooksList.data, state.playbooks),
    })),
    on(PlaybooksActions.fetchPlaybooksFailed, (state) => ({
        ...state,
        fetchPlaybooksRequestState: HttpActionState.Failed,
        paging: initialState.paging,
        playbooks: initialState.playbooks
    })),


    on(PlaybooksActions.fetchCategories, (state,) => ({
        ...state,
        fetchCategoriesRequestState: HttpActionState.Busy
    })),

    on(PlaybooksActions.fetchCategoriesSucceeded, (state,{categories}) => ({
        ...state,
        fetchCategoriesRequestState: HttpActionState.Done,
        categories:categories.data
    })),

    on(PlaybooksActions.fetchPlaybooksFailed, (state) => ({
        ...state,
        fetchCategoriesRequestState: HttpActionState.Failed
    })),
    
    on(PlaybooksActions.addNewCategorySucceeded, (state,{category}) => ({
        ...state,
        categories: addCategoryIfNotExists(state.categories, category)
    })),

    on(PlaybooksActions.updatePlaybookSucceeded, (state, {playbooksItem}) => ({
        ...state,
        playbooks: playbookListingAdapter.updateOne({
            id: playbooksItem.id,
            changes: mapPlaybookUpdateToListingPlaybook(state, playbooksItem)
        }, state.playbooks)
    })),


    on(PlaybooksActions.updateGuidelineSucceeded, (state, {playbooksItem, playbookId}) => ({
    ...state,
            playbooks: playbookListingAdapter.updateOne({
            id: playbookId,
            changes: {
                playbook_guidelines_count: playbooksItem?.length ?? 0
            }
        }, state.playbooks)
    })),


    on(PlaybooksActions.deletePlaybook, (state) => ({
        ...state,
        deletePlaybookRequestState: HttpActionState.Busy
    })),

    on(PlaybooksActions.deletePlaybookSuccess, (state, {playbookId}) => ({
        ...state,
        playbooks: playbookListingAdapter.removeOne(playbookId, state.playbooks),
        deletePlaybookRequestState: HttpActionState.Done
    })),

    on(PlaybooksActions.deletePlaybookFailure, (state) => ({
        ...state,
        deletePlaybookRequestState: HttpActionState.Failed
    })),

)

function addCategoryIfNotExists(categories: IPlaybookCategoryDTO[], category: IPlaybookCategoryDTO): IPlaybookCategoryDTO[] {
   const exists = categories.some(c => c.id === category.id);
   return exists ? categories : [ ...categories, category] 
}

function mapPlaybookUpdateToListingPlaybook(state: IPlaybookListeningState, playbooksItem: IPlaybooksItemDTO): Partial<IPlaybooksItemDTO> {
    const category = state.categories.find(c => c.id === playbooksItem.playbook_category_id);
    return {
        ...playbooksItem,
        playbook_category: category
    }
}
 